const FilterForm = (props) => {
  const {
    filteredValues,
    filterGrid,
    onFilterSubmit,
    propertyView,
    isPopup = false,
  } = props;
  const statusValues = ["Active", "Contingent - Show", "Pending", "Closed"];
  const propTypeValues = [
    "Residential",
    "Business Opportunity",
    "Commercial Sale",
    "Commercial Lease",
    "Residential Income",
    "Land",
    "Residential Lease",
  ];
  const bedroomValues = [
    {
      label: "Any",
      value: "0",
    },
    {
      label: "1+",
      value: "1",
    },
    {
      label: "2+",
      value: "2",
    },
    {
      label: "3+",
      value: "3",
    },
    {
      label: "4+",
      value: "4",
    },
    {
      label: "5+",
      value: "5",
    },
  ];
  const bathroomValues = [
    {
      label: "Any",
      value: 0,
    },
    {
      label: "1+",
      value: 1,
    },
    {
      label: "2+",
      value: 2,
    },
    {
      label: "3+",
      value: 3,
    },
    {
      label: "4+",
      value: 4,
    },
    {
      label: "5+",
      value: 5,
    },
  ];

  return (
    <form>
      {/* {propertyView === "Grid" && (
        <>
          <label className="form-label">Search Location</label>
          <form className="app-search ">
            <div className="position-relative">
              <input
                type="search"
                className="form-control border-0"
                autoComplete="off"
                value={filteredValues.searchValue}
                onChange={filterGrid}
                name="searchValue"
              />
              <i className="ri-search-line search-widget-icon"></i>
            </div>
          </form>
        </>
      )} */}

      <h5 className="text-dark fw-medium">Price:</h5>
      <div className="formCost d-flex gap-2 align-items-center mt-3">
        <input
          name="minPrice"
          className="form-control form-control-sm"
          type="text"
          placeholder="Min Price"
          value={filteredValues.minPrice}
          onChange={filterGrid}
        />
        <span className="fw-semibold text-muted">to</span>
        <input
          name="maxPrice"
          className="form-control form-control-sm"
          type="text"
          placeholder="Max Price"
          value={filteredValues.maxPrice}
          onChange={filterGrid}
        />
      </div>

      <h5 className="text-dark fw-medium my-3">Status :</h5>
      <div className="row g-1">
        {statusValues.map((item, index) => (
          <div className="col-lg-6" key={index}>
            <div className="mb-2">
              <input
                className="form-check-input"
                name="propStatus"
                type="radio"
                value={item}
                checked={filteredValues.propStatus === item}
                onChange={filterGrid}
              />
              <label className="form-check-label ms-1">{item}</label>
            </div>
          </div>
        ))}
      </div>

      <h5 className="text-dark fw-medium my-3">Property Type :</h5>
      <div className="row g-1">
        {propTypeValues.map((item, index) => (
          <div className="mb-2" key={index}>
            <input
              className="form-check-input"
              name="propType"
              type="radio"
              value={item}
              checked={filteredValues.propType === item}
              onChange={filterGrid}
            />
            <label className="form-check-label ms-1">{item}</label>
          </div>
        ))}
      </div>

      <h5 className="text-dark fw-medium my-3">Bedrooms :</h5>
      <div className="beds-buttons">
        {bedroomValues.map((item, index) => (
          <div key={index}>
            <input
              type="radio"
              name="bedrooms"
              className="btn-check"
              id={`bedrooms${index}`}
              onChange={filterGrid}
              value={item.value}
              checked={filteredValues.bedrooms === item.value}
            />
            <label
              className="btn btn-outline-primary"
              htmlFor={`bedrooms${index}`}
            >
              {item.label}
            </label>
          </div>
        ))}
      </div>

      <h5 className="text-dark fw-medium my-3">Bathrooms :</h5>
      <div className="beds-buttons">
        {bedroomValues.map((item, index) => (
          <div key={index}>
            <input
              type="radio"
              name="bathrooms"
              className="btn-check"
              id={`bathrooms${index}`}
              onChange={filterGrid}
              value={item.value}
              checked={filteredValues.bathrooms === item.value}
            />
            <label
              className="btn btn-outline-primary"
              htmlFor={`bathrooms${index}`}
            >
              {item.label}
            </label>
          </div>
        ))}
      </div>

      {/* <button
        type="button"
        className="btn btn-primary w-100 mt-3"
        onClick={onFilterSubmit}
        data-bs-dismiss={propertyView === "List" ? "modal" : ""}
        aria-label={propertyView === "List" ? "Close" : ""}
      >
        Apply
      </button> */}

      {isPopup ? (
        <button
          type="button"
          className="btn btn-primary w-100 mt-3"
          onClick={onFilterSubmit}
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          Apply
        </button>
      ) : (
        <button
          type="button"
          className="btn btn-primary w-100 mt-3"
          onClick={onFilterSubmit}
        >
          Apply
        </button>
      )}
    </form>
  );
};

export default FilterForm;
